import React from 'react';
import { Link } from 'react-router-dom';

const ModulosView = ({ modulos = [] }) => {
	if (modulos.length === 0) {
		return (
			<div className="text-center py-4">
				<i className="bi bi-info-circle me-2"></i>
				Selecione um curso para visualizar seus módulos
			</div>
		);
	}

	return (
		<div className="d-flex flex-column mt-2">
			{modulos.map((modulo) => (
				<div className="card mt-1 py-3 px-4 bg-grey-light" key={modulo.id}>
					<div className="d-flex align-items-center">
						<div className="d-flex flex-column ms-3 w-100">
							<h6 className="fw-medium text-dark mb-0 fs-6">{modulo.nome}</h6>
							<hr />
							<div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between fs-7">
								<span className="text-dark fw-normal text-uppercase mb-2 mb-md-0">
									{modulo.descricao ? modulo.descricao : "Sem descrição"}
								</span>
								<div>
									<Link to={`/aulas/${modulo.id}`} className="text-primary cursor-pointer link fw-medium fs-6 me-3 d-flex align-items-center">
										<i className="bi bi-eye me-1"></i>
										Visualizar
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default ModulosView; 